/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BudgetData_project$ref = any;
type BudgetPageHeader_project$ref = any;
type Details_project$ref = any;
type ExpenseDetails_project$ref = any;
type InvoiceBudgetData_project$ref = any;
type InvoiceDetails_project$ref = any;
type TimeBudgetData_project$ref = any;
type TimeDetails_project$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BudgetPage_project$ref: FragmentReference;
declare export opaque type BudgetPage_project$fragmentType: BudgetPage_project$ref;
export type BudgetPage_project = {|
  +id: string,
  +financialDataAvailability: ?number,
  +$fragmentRefs: BudgetPageHeader_project$ref & BudgetData_project$ref & TimeBudgetData_project$ref & Details_project$ref & InvoiceDetails_project$ref & TimeDetails_project$ref & ExpenseDetails_project$ref & InvoiceBudgetData_project$ref,
  +$refType: BudgetPage_project$ref,
|};
export type BudgetPage_project$data = BudgetPage_project;
export type BudgetPage_project$key = {
  +$data?: BudgetPage_project$data,
  +$fragmentRefs: BudgetPage_project$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BudgetPage_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "financialDataAvailability",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BudgetPageHeader_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BudgetData_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeBudgetData_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Details_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceDetails_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeDetails_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExpenseDetails_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceBudgetData_project"
    }
  ],
  "type": "ProjectType"
};
// prettier-ignore
(node/*: any*/).hash = '38ad5ee2d1ba98a91a67c166a1fd01d2';

module.exports = node;
